var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEmptyStateIdeasCuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 0,
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.58,
    y: 22.09,
    width: 71.56,
    height: 20.55,
    rx: 4.36,
    ry: 4.36,
    transform: "translate(-3.82 5.87) rotate(-7.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.95,47.14c-1.06,0-2.09-.35-2.95-1.01-1.03-.79-1.69-1.94-1.85-3.22l-1.53-11.73c-.17-1.29,.18-2.56,.97-3.59s1.94-1.69,3.22-1.85l62.32-8.12c1.29-.16,2.56,.17,3.59,.97,1.03,.79,1.69,1.94,1.85,3.22l1.53,11.73c.35,2.66-1.53,5.1-4.19,5.44L13.59,47.1c-.21,.03-.43,.04-.64,.04Zm60.81-28.57c-.17,0-.34,.01-.51,.03L10.93,26.73c-2.11,.27-3.6,2.21-3.33,4.32l1.53,11.73c.13,1.02,.66,1.93,1.47,2.56,.82,.63,1.83,.9,2.85,.77l62.32-8.12c2.11-.28,3.6-2.21,3.33-4.32l-1.53-11.73c-.13-1.02-.66-1.93-1.47-2.56-.68-.52-1.5-.8-2.34-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18.46,
    cy: 35.6,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.46,39.6c-.88,0-1.73-.29-2.43-.83-.85-.65-1.39-1.59-1.53-2.65s.14-2.11,.8-2.96c.65-.85,1.59-1.39,2.65-1.53,2.19-.29,4.2,1.26,4.48,3.45h0c.28,2.19-1.26,4.2-3.45,4.48-.17,.02-.35,.03-.52,.03Zm0-7c-.13,0-.26,0-.39,.03-.79,.1-1.5,.51-1.99,1.14s-.7,1.42-.6,2.22c.1,.79,.51,1.5,1.14,1.99,.64,.49,1.42,.71,2.22,.6,1.64-.21,2.8-1.72,2.59-3.36-.2-1.51-1.49-2.61-2.97-2.61Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.8,
    y: 30.79,
    width: 41.59,
    height: 1,
    transform: "translate(-3.6 6.91) rotate(-7.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.75,
    y: 46.41,
    width: 71.56,
    height: 20.55,
    rx: 4.36,
    ry: 4.36,
    transform: "translate(-6.93 6.49) rotate(-7.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.12,71.47c-1.06,0-2.09-.35-2.95-1.01-1.03-.79-1.69-1.94-1.85-3.22l-1.53-11.73c-.34-2.66,1.53-5.1,4.19-5.44l62.32-8.12c1.29-.17,2.56,.18,3.59,.97,1.03,.79,1.69,1.94,1.85,3.22l1.53,11.73c.17,1.29-.18,2.56-.97,3.59s-1.94,1.69-3.22,1.85l-62.32,8.12c-.21,.03-.43,.04-.64,.04Zm60.81-28.57c-.17,0-.34,.01-.51,.03L14.1,51.06c-2.11,.28-3.6,2.21-3.33,4.32l1.53,11.73c.13,1.02,.66,1.93,1.47,2.56,.82,.63,1.83,.9,2.85,.77l62.32-8.12c2.11-.27,3.6-2.21,3.33-4.32l-1.53-11.73c-.13-1.02-.66-1.93-1.47-2.56-.68-.52-1.5-.8-2.34-.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.63,
    cy: 59.93,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.62,63.93c-.88,0-1.72-.29-2.43-.83-.85-.65-1.39-1.59-1.53-2.65-.29-2.19,1.26-4.2,3.45-4.48,1.06-.13,2.11,.14,2.96,.8,.85,.65,1.39,1.59,1.53,2.65h0c.14,1.06-.14,2.11-.8,2.96-.65,.85-1.59,1.39-2.65,1.53-.18,.02-.35,.03-.53,.03Zm.02-7c-.13,0-.26,0-.39,.03-1.64,.21-2.8,1.72-2.59,3.36,.1,.79,.51,1.5,1.14,1.99,.64,.49,1.42,.7,2.22,.6,.79-.1,1.5-.51,1.99-1.14,.49-.63,.7-1.42,.6-2.22h0c-.1-.79-.51-1.5-1.15-1.99-.53-.41-1.17-.62-1.82-.62Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.96,
    y: 55.12,
    width: 41.59,
    height: 1,
    transform: "translate(-6.71 7.52) rotate(-7.4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateIdeasCuration);
export default __webpack_public_path__ + "static/media/illustration_empty-state-ideas-curation.a841d4993735be36b368d966e07dee44.svg";
export { ForwardRef as ReactComponent };